import React from 'react';
import { useCart } from '../context/CartContext';
import { useNavigate, useLocation } from 'react-router-dom';
import { CartItem } from '../context/CartContext';

const CartFooter: React.FC = () => {
  const { cart } = useCart();
  const navigate = useNavigate();
  const location = useLocation();

  const totalItems = cart.reduce((sum: number, item: CartItem) => sum + item.services.length, 0);

  // Hide footer if we're on the cart page or if there are no cart items
  if (location.pathname === '/cart' || totalItems === 0) return null;

  const displayModel = cart[0]?.model;
  const hasCartItems = totalItems > 0;

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-white shadow-[0_-8px_16px_-4px_rgba(0,0,0,0.1)] border-t border-gray-200">
      <div className="container mx-auto px-4 py-3">
        <div className="flex items-center justify-between">
          <div 
            onClick={() => navigate('/cart')}
            className="flex items-center cursor-pointer group"
          >
            {displayModel && (
              <div className="w-10 h-10 rounded-lg bg-gray-50 p-1 mr-3 flex items-center justify-center">
                {displayModel.image && displayModel.image.trim() !== '' ? (
                  <img
                    src={displayModel.image}
                    alt={displayModel.name}
                    className="w-full h-full object-contain"
                    onError={(e) => {
                      // Hide image and show fallback icon if image fails to load
                      e.currentTarget.style.display = 'none';
                      const fallbackIcon = e.currentTarget.nextElementSibling as HTMLElement;
                      if (fallbackIcon) fallbackIcon.style.display = 'block';
                    }}
                  />
                ) : null}
                <i 
                  className="fas fa-mobile-alt text-gray-400 text-lg"
                  style={{ display: (displayModel.image && displayModel.image.trim() !== '') ? 'none' : 'block' }}
                ></i>
              </div>
            )}
            <div className="flex items-center">
              <i className="fas fa-shopping-cart text-gray-400 text-lg mr-2"></i>
              <span className="text-sm font-medium text-gray-600 group-hover:text-minto-500 transition-colors">
                {hasCartItems ? (
                  `${totalItems} ${totalItems === 1 ? 'Item' : 'Items'}`
                ) : (
                  displayModel ? `${displayModel.name} Services` : 'No Items'
                )}
              </span>
              <i className="fas fa-chevron-right text-gray-400 text-xs ml-1.5 group-hover:text-minto-500 transition-colors"></i>
            </div>
          </div>
          <button
            onClick={() => navigate('/cart')}
            className="px-6 py-2.5 rounded-xl font-medium text-base text-white bg-minto-500 hover:bg-minto-600 active:bg-minto-700 transition-colors shadow-md hover:shadow-lg"
            disabled={!hasCartItems}
            style={{ opacity: hasCartItems ? 1 : 0.6 }}
          >
            {hasCartItems ? 'View Cart' : 'Add Services'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CartFooter; 